import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface VaPostagemProtectedRouteProps {
  children: ReactNode;
}

export function VaPostagemProtectedRoute({ children }: VaPostagemProtectedRouteProps) {
  const { user, userRole, userRoleData, isLoading } = useAuth();

  if (isLoading || (user && userRole === null)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Allow va_postagem employees and admins
  const isVaPostagem = userRole === "employee" && userRoleData?.employee_type === "va_postagem";
  const isAdmin = userRole === "admin";

  if (!isVaPostagem && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
